import { useEffect } from 'react';
import { init } from '@elastic/apm-rum';
import { useRouter } from 'next/router';

type Environment = 'production' | 'development' | 'staging';

const useElasticApm = () => {
  const router = useRouter();

  let environment: Environment = 'development';
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    environment = 'production';
  } else if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'staging' ||
    process.env.VERCEL_GIT_COMMIT_REF === 'stg'
  ) {
    environment = 'staging';
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_APM_SERVER_URL) {
      const rawTransactionSampleRate = process.env.NEXT_PUBLIC_TRANSACTION_SAMPLE_RATE;
      const parsedTransactionSampleRate =
        typeof rawTransactionSampleRate === 'string' ? parseFloat(rawTransactionSampleRate) : NaN;
      const transactionSampleRate =
        Number.isFinite(parsedTransactionSampleRate) &&
        parsedTransactionSampleRate >= 0 &&
        parsedTransactionSampleRate <= 1
          ? parsedTransactionSampleRate
          : 1.0;

      const apm = init({
        serviceName: process.env.PACKAGE_NAME,
        serviceVersion: process.env.PACKAGE_VERSION,
        serverUrl: process.env.NEXT_PUBLIC_APM_SERVER_URL,
        environment,

        transactionSampleRate,
        instrument: true,
        breakdownMetrics: true,
        distributedTracingOrigins: process.env.NEXT_PUBLIC_BFF_DOMAIN
          ? [process.env.NEXT_PUBLIC_BFF_DOMAIN]
          : undefined,
      });
      window.apm = apm;
    }
  }, [environment]);

  useEffect(() => {
    if (window?.apm && window?.apm?.isActive() && router?.pathname) {
      window.apm.startTransaction(router?.pathname, 'route-change', {
        managed: true,
        canReuse: true,
      });
    }
  }, [router?.pathname]);
};

export default useElasticApm;
